import React, { FC } from "react";
import { Box, StepIconProps } from "@mui/material";
import Colors from "../../theme/Colours";

import New from "../../assets/stages/new.svg";
import Approved from "../../assets/stages/approved.svg";
import Processing from "../../assets/stages/processing.svg";
import ReadyForDispatch from "../../assets/stages/readyfordispatch.svg";
import Dispatched from "../../assets/stages/dispatched.svg";
import Delivered from "../../assets/stages/delivered.svg";

const stageImages: { [key: number]: string } = {
  1: New,
  2: Approved,
  3: Processing,
  4: ReadyForDispatch,
  5: Dispatched,
  6: Delivered,
};

export const StepIcon: FC<StepIconProps> = (props) => {
  const { active, icon } = props;

  const size = {
    width: { xs: "26px", sm: "64.94px" },
    height: { xs: "26px", sm: "62.83px" },
  };

  const iconStyle = {
    ...size,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: active ? Colors.primaryButtonOrange : Colors.background2,
    border: `1px ${Colors.primaryButtonOrange} ${!active ? "solid" : "none"}`,
    zIndex: 1,
  };

  return (
    <Box sx={iconStyle}>
      <Box
        component="img"
        src={
          typeof icon === "number" && stageImages[icon]
            ? stageImages[icon]
            : New
        }
        alt={`Stage ${icon}`}
        sx={{
          width: { xs: "16px", sm: "23.59px" },
          height: { xs: "16px", sm: "23.72px" },
          objectFit: "contain",
          filter: active ? "brightness(0) invert(1)" : "none",
        }}
      />
    </Box>
  );
};
